import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import "./styles/style.css";
import CheckoutWizard from "./CheckoutWizard";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";

export type CheckoutPageProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export type CheckoutPageState = {
  showAuthenticationModal?: boolean;
  payload: AuthorizationResponsePayload;
};

export const CheckoutPage = (props: CheckoutPageProps) => {
  const state: CheckoutPageState = {
    showAuthenticationModal: false,
    payload: null,
  };

  const showLoginDialog = () => {
    if (props.onApply) props.onApply();
  };

  const getPayload = (): AuthorizationResponsePayload => {
    return props.payload ?? state.payload;
  };
  return (
    <Container style={{ maxWidth: "100%" }}>
      <NavBar />
      <Container fluid className="checkout-banner">
        <Container>
          <Row>
            <Col xl={8} lg={5} md={7}></Col>
            <Col xl={4} lg={6} md={5}>
              <h2 className="title">Secure Checkout</h2>
              <p className="wow"></p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid>
        <CheckoutWizard
          payload={getPayload()}
          onApply={() => showLoginDialog()}
        />
      </Container>
    </Container>
  );
};
